module.exports = __webpack_public_path__ + "static/media/icon-change-meal.179c1990.svg";